const createEndpoint = (path: string) => path

export const AUTH_ENDPOINTS = {
  ME: createEndpoint('me'),
  ME_PERMISSIONS: createEndpoint('/me-permissions'),
}

export const SIDE_MENU_ENDPOINTS = {
  LISTED_SIDE_MENU: createEndpoint('/listed-properties-side-menu'),
}

export const FILE_ENDPOINTS = {
  UPLOAD_IMAGE: createEndpoint('/upload-image'),
}

export const VERIFICATION_ENDPOINTS = {
  START_IDENTITY: createEndpoint('/identity-verification/start'),
  IDENTITY_DOCUMENTS: createEndpoint('/identity-documents'),
  ME_VERIFICATION: createEndpoint('/me/verification'),
  SUPPORT_IDENTITY_VERIFICATIONS: createEndpoint('/support/identity-verifications'),
  SUPPORT_PROPERTY_VERIFICATIONS: createEndpoint('/support/property-verifications'),
}

export const FAVORITES_ENDPOINTS = {
  LOAD_FAVORITES: createEndpoint('/favorites'),
  ADD_FAVORITE: createEndpoint('/favorites'),
  REMOVE_FAVORITE: createEndpoint('/favorites'),
}

export const MESSAGES_ENDPOINTS = {
  LOAD_MESSAGES: createEndpoint('/messages'),
}

export const NAVIGATION_ENDPOINTS = {
  AUTH: createEndpoint('/navigation'),
  DEFAULT: createEndpoint('/navigation'),
}

export const PROPERTY_ENDPOINTS = {
  LOAD_PROPERTIES: createEndpoint('/properties'),
  LOAD_PROPERTY: createEndpoint('/listed-property'),
  LOAD_MY_PROPERTIES: createEndpoint('/my-properties'),
  CREATE_PROPERTY: createEndpoint('/create-property'),
  VERIFY_PROPERTY: createEndpoint('/verify-property'),
  LOAD_TAGS: createEndpoint('/tags'),
  SUBMIT_APPLICATION: createEndpoint('/property-application'),
  OWNER_LISTING_MANAGER: createEndpoint('/owner-listing-manager'),
  CONTRACTS: createEndpoint('/contracts'),
  BILLING_CHARGES: createEndpoint('/billing-charges'),
  BILLING_PAYMENTS: createEndpoint('/billing-payments'),
  DELINQUENCY_CASES: createEndpoint('/delinquency-cases'),
  SERVICES_OFFERS: createEndpoint('/services-offers'),
  SERVICES_ORDERS: createEndpoint('/services-orders'),
  SUPPORT_TICKETS: createEndpoint('/support-tickets'),
  SUPPORT_MODERATION_ACTIONS: createEndpoint('/support-moderation-actions'),
  ADMIN_USERS: createEndpoint('/admin-users'),
  SUPPORT_INVITATIONS: createEndpoint('/support-invitations'),
}

export const USERS_ENDPOINTS = {
  LOAD_USERS: createEndpoint('users'),
  LOAD_USER: createEndpoint('user'),
  UPDATE_PROFILE: createEndpoint('user'),
}

export const WIZARD_ENDPOINTS = {
  REGISTER_PROPERTY_STEPS: createEndpoint('/wizard/list-property'),
  REGISTER_PROPERTY_QUICK_STEPS: createEndpoint('/wizard/quick-list-property'),
  AUTH_REGISTER_PROPERTY_QUICK_STEPS: createEndpoint('/wizard/auth-quick-list-property'),
}

export const BUG_REPORT_ENDPOINTS = {
  SUBMIT_BUG_REPORT: createEndpoint('/bug-report'),
}

export const CONTACT_ENDPOINTS = {
  SUBMIT: createEndpoint('/contact'),
}

export const FILTER_ENDPOINTS = {
  LOAD_FILTER_OPTIONS: createEndpoint('/filter-options'),
  LISTING_NEIGHBORHOODS: createEndpoint('/listing-neighborhoods'),
}

export const SEARCH_ALERTS_ENDPOINTS = {
  BASE: createEndpoint('/search-alerts'),
}

export const EMAIL_CONFIRM_ENDPOINTS = {
  BASE: createEndpoint('/email-confirm'),
}

export const PASSWORD_RESET_ENDPOINTS = {
  BASE: createEndpoint('/password-reset'),
}

export const ENDPOINTS = {
  AUTH: AUTH_ENDPOINTS,
  SIDE_MENU: SIDE_MENU_ENDPOINTS,
  NAVIGATION: NAVIGATION_ENDPOINTS,
  PROPERTY: PROPERTY_ENDPOINTS,
  FAVORITES: FAVORITES_ENDPOINTS,
  MESSAGES: MESSAGES_ENDPOINTS,
  USERS: USERS_ENDPOINTS,
  WIZARD: WIZARD_ENDPOINTS,
  BUG_REPORT: BUG_REPORT_ENDPOINTS,
  CONTACT: CONTACT_ENDPOINTS,
  FILE: FILE_ENDPOINTS,
  VERIFICATION: VERIFICATION_ENDPOINTS,
  FILTER: FILTER_ENDPOINTS,
  SEARCH_ALERTS: SEARCH_ALERTS_ENDPOINTS,
  EMAIL_CONFIRM: EMAIL_CONFIRM_ENDPOINTS,
  PASSWORD_RESET: PASSWORD_RESET_ENDPOINTS,
}
